//@ts-nocheck
import React from "react";
import { Table, TableBody, TableContainer, TableRow, TableCell, Checkbox } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTableHeadCell from "lib/Tables/EditableTable/DataTableHeadCell";

interface OcrolusDataTableProps {
  columns: any[];
  data: any[];
  rowKey: string;

  selectable?: boolean;
  selectedRows?: any[];
  onSelectRow?: (rowKey: any) => void;
  onSelectAll?: () => void;

  renderTotal?: (accessor: string) => any;
  totalColumns?: string[];
}

const OcrolusDataTable: React.FC<OcrolusDataTableProps> = ({
  columns,
  data,
  rowKey,
  selectable = false,
  selectedRows = [],
  onSelectRow,
  onSelectAll,
  renderTotal,
  totalColumns = [],
}) => {
  const allSelected = selectable && data.length > 0 && selectedRows.length === data.length;

  return (
    <TableContainer sx={{ boxShadow: "none" }}>
      <Table style={{ width: "100%", borderCollapse: "collapse" }}>
        <MDBox component="thead">
          <TableRow>
            {selectable && (
              <TableCell
                align="center"
                padding="checkbox"
                sx={{ padding: "3px", width: "30px", maxWidth: "30px" }}
              >
                <Checkbox checked={allSelected} onChange={onSelectAll} color="primary" />
              </TableCell>
            )}

            {columns.map((column: any) => (
              <DataTableHeadCell
                key={column.accessor}
                align={column.align || "left"}
                sx={{ padding: "8px" }}
              >
                <MDTypography fontSize={"0.75rem"} fontWeight="bold">
                  {column.Header}
                </MDTypography>
              </DataTableHeadCell>
            ))}
          </TableRow>
        </MDBox>

        <TableBody>
          {data.map((row: any) => (
            <TableRow key={row[rowKey]}>
              {selectable && (
                <TableCell
                  align="center"
                  padding="checkbox"
                  sx={{ padding: "3px", width: "30px", maxWidth: "30px" }}
                >
                  <Checkbox
                    checked={selectedRows.includes(row[rowKey])}
                    onChange={() => onSelectRow?.(row[rowKey])}
                    color="primary"
                  />
                </TableCell>
              )}

              {columns.map((column: any) => (
                <TableCell
                  key={column.accessor}
                  sx={{
                    padding: "8px",
                    textAlign: column.align || "center",
                    width: column.width || "auto",
                  }}
                >
                  <MDTypography fontSize={"0.75rem"} fontWeight="regular">
                    {column.Cell ? column.Cell({ row }) : row[column.accessor]}
                  </MDTypography>
                </TableCell>
              ))}
            </TableRow>
          ))}

           {renderTotal && (
            <TableRow key="totals">
              {selectable && <TableCell />}

              <TableCell sx={{ padding: "8px" }}>
                <MDTypography fontSize={"0.75rem"} fontWeight={"bold"}>
                  TOTAL:
                </MDTypography>
              </TableCell>

              {columns.map((column: any, index: number) => {
                if (index === 0) return null;

                if (totalColumns.includes(column.accessor)) {
                  return (
                    <TableCell key={column.accessor} sx={{ padding: "8px" }}>
                      <MDTypography fontSize={"0.75rem"} fontWeight={"bold"}>
                        {renderTotal(column.accessor)}
                      </MDTypography>
                    </TableCell>
                  );
                }

                return (
                  <TableCell key={column.accessor} sx={{ padding: "8px" }}>
                    <MDTypography fontSize={"0.75rem"}></MDTypography>
                  </TableCell>
                );
              })}
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OcrolusDataTable;
